@if (searchResultComponents?.length) {
    <his-heading [value]="getPageTitle() | hisUi" />

    <button type="submit" iconPos="left" (click)="newSearch()" class="newSearchButton">
      <span>{{'de.his.javang.newsearch'|hisUi}}</span>
    </button>
    <button class="changeSearchButton" type="submit" iconPos="left" (click)="changeSearch()">
      <span>{{'de.his.javang.changesearch'|hisUi}}</span>
    </button>
    <br><br>
}
<p-tabs [value]="selectedTabIndex" (onChange)="tabChanged($event)">
    <p-tablist>
        @for (tab of tabsToDisplay; track tab.i18nKey; let i = $index) {
            <p-tab [value]="i">
                {{tab.i18nKey | hisUi}}
            </p-tab>
        }
    </p-tablist>

    <p-tabpanels>
        @for (tab of tabsToDisplay; track tab.i18nKey; let i = $index) {
            <p-tabpanel [value]="i">
                @if (loadedTabs.includes(i)) {
                  <his-search-result #searchResult
                      [showTitle]="false"
                      [showNewSearchButton]="false"
                      [showChangeSearchButton]="false"
                      [searchShowPrintviewButton]="false"
                      [searchConfigFile]="searchConfigFile"
  
                      [defaultActionRoute]="tab.defaultActionRoute"
                      [idColumn]="tab.idColumn"
                      [defaultColumn]="tab.defaultColumn"
                      [resultConfigFile]="tab.resultConfigFile"
                      (finishedInitialLoad)="searchLoaded.emit(searchResult.search)">
  
                      @if(tab.customButtonsTemplate){
                          <ng-container customResultButtons>
                              <ng-container
                                  *ngTemplateOutlet="tab.customButtonsTemplate">
                              </ng-container>
                          </ng-container>
                      }
  
                      <ng-template #rowAction let-row="row">
                          <ng-container *ngTemplateOutlet="tab.rowActionTemplate; context: {$implicit: row, row: row}"></ng-container>
                      </ng-template>
                  </his-search-result>
                }
            </p-tabpanel>
        }
    </p-tabpanels>
</p-tabs>